module.exports = __webpack_public_path__ + "static/media/co-dokaze-mama.626a4186.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/co-dokaze-mama.png
// module id = 486
// module chunks = 0